<script setup></script>

<template>
    <div
        class="absolute -top-[15px] left-1/2 z-50 -translate-x-1/2 rounded-full bg-[#fab22b] px-4 py-2 text-sm font-bold uppercase text-black"
    >
        Add on
    </div>
</template>
